import { useState, useEffect } from 'react';
import { apiFetch, API } from '../lib/api';

// Fetches the current garage's own invoice/job-card branding (business name,
// phone, email) set in Settings > GST, so print templates show each garage's
// own details instead of a hardcoded one. Falls back to "Garage" while
// loading / if unset.
export const useGarageBranding = () => {
  const [branding, setBranding] = useState({ businessName: 'Garage', phone: '', email: '' });

  useEffect(() => {
    let active = true;
    apiFetch(`${API}/settings/gst`)
      .then(async (res) => {
        if (!res.ok) return;
        const data = await res.json();
        if (!active) return;
        setBranding({
          businessName: data.business_name || 'Garage',
          phone: data.phone || '',
          email: data.email || '',
        });
      })
      .catch(() => { /* keep default */ });
    return () => { active = false; };
  }, []);

  return branding.businessName;
};

// Like useGarageBranding() but returns the full {businessName, phone, email}
// object, for print templates that also show contact info (e.g. Job Cards).
export const useGarageBrandingFull = () => {
  const [branding, setBranding] = useState({ businessName: 'Garage', phone: '', email: '' });

  useEffect(() => {
    let active = true;
    apiFetch(`${API}/settings/gst`)
      .then(async (res) => {
        if (!res.ok) return;
        const data = await res.json();
        if (!active) return;
        setBranding({
          businessName: data.business_name || 'Garage',
          phone: data.phone || '',
          email: data.email || '',
        });
      })
      .catch(() => { /* keep default */ });
    return () => { active = false; };
  }, []);

  return branding;
};

